var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.transf === false)?_c('c-prg-tree',{attrs:{"table-data":_vm.tableData,"accessLevel":_vm.accessLevel}}):_c('c-transf-tree',{attrs:{"table-data":_vm.tableData,"accessLevel":_vm.accessLevel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }